import * as React from "react";
import * as _ from "lodash";
import { connect, Dispatch } from "react-redux";
import { IApplicationState, AppActionCreators, IRccapState, IRccapListResponse, RccapActionCreators } from "@nkr/store/index";
import { RccapStatus } from "@nkr/enums/index";
import { GridWrapper } from "./styles";
import { AgGridReact } from "ag-grid-react";
import { ColDef, IHeaderParams, ICellRendererParams, GridReadyEvent } from "ag-grid-community";
import RankRenderer from "@nkr/views/admin/center/list/common/rank-renderer";
import SortableHeaderComponent from "@nkr/views/admin/center/list/common/sortable-header";
import { Button } from "react-bootstrap";
import Grid from './grid';

interface IOwnProps {
    centerId: number,
    status: number,
    onGridReady: (e: GridReadyEvent) => void
}

interface IStateProps {
    rccap: IRccapState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getRccapList: (centerId: number, status: RccapStatus) => Promise<IRccapListResponse>
}

type TProps =
    IOwnProps
    & IStateProps
    & IDispatchProps;

class RccapList extends React.Component<TProps, {}> {
    componentDidMount = () => {
        this.getData();
    }

    componentWillReceiveProps = (nextProps: TProps) => {
        if (nextProps.centerId != this.props.centerId || nextProps.status != this.props.status)
            this.getData();
    }

    handleEdit = (id: number) => {
        window.location.href = `/admin/rccap/${id}`;
    }

    private getData = () => {
        this.props.showLoading("Getting rccap list, one moment please...").then(() => {
            this.props.getRccapList(this.props.centerId, this.props.status).then(response => {
                this.props.hideLoading();
            });
        });
    }

    render = () => {
        const rccaps = this.props.status == RccapStatus.Accepted ?
            _.orderBy(this.props.rccap.list, (rccap) => {
                return new Date(rccap.dueDate);
            }, ['desc'])
            :
            _.orderBy(this.props.rccap.list, (rccap) => {
                return rccap.swapChainNumber;
            }, ['asc']);

        

        return (
            <>
                <Grid data={rccaps} onEdit={this.handleEdit} onGridReady={this.props.onGridReady} />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        rccap: appState.rccap
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => { return dispatch(AppActionCreators.showLoadingAsync(message)); },
        hideLoading: () => { dispatch(AppActionCreators.hideLoading()); },
        getRccapList: (centerId, status) => { return dispatch(RccapActionCreators.getRccapList(centerId, status)); }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(RccapList)